import { render } from "./Scenario1.vue?vue&type=template&id=ddb4f25a"
import script from "./Scenario1.vue?vue&type=script&lang=js"
export * from "./Scenario1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__